import { connect } from 'react-redux';
import { BulkActionDataTypes } from '../../../services/bulk-update-type-data';
import get from 'lodash.get';
import Global from '../../../store/global-selectors';

import BulkUpdateMenuItems from '../../../components/bulk-update-menu/bulk-update-menu-items';
// TODO: instead of passing the idSelector we can pass just a straight collection of Id's, perhaps the same thing for getAdditionalDisabledCriteria
const mapStateToProps = (state, props) => {
  const { idsSelector, actionSections, dataTypeKey } = props;
  const bulkUpdateTypeData = BulkActionDataTypes.getBulkUpdateTypeData(dataTypeKey);
  const ids = idsSelector();
  const allSelected = Global.selectSelectedOrdersAreAllOrdersSelected(state);
  const getAdditionalDisabledCriteria = get(props, 'getAdditionalDisabledCriteria') || (() => false);

  const optionsShouldBeDisabled = (!allSelected && ids.length === 0) || getAdditionalDisabledCriteria(state);
  return {
    optionsShouldBeDisabled,
    ids,
    actionSections,
    dataTypeKey,
    bulkUpdateTypeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { optionsShouldBeDisabled, ids, bulkUpdateTypeData, actionSections } = stateProps;
  const { dispatch } = dispatchProps;

  const actions = actionSections.map((section) => {
    return {
      ...section,
      ...ownProps,
      ids,
      actions: section.actions.map((action) => {
        return {
          ...action,
          disabled: ownProps.actionsDisabled || optionsShouldBeDisabled,
          actionHandler: action.makeHandler(dispatch, bulkUpdateTypeData),
        };
      }),
    };
  });

  return {
    ...ownProps,
    ids,
    optionsShouldBeDisabled,
    actionSections: actions,
  };
};

export const BaseOrdersBulkUpdateMenuItemsContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(BulkUpdateMenuItems);
